import React from "react";
import { useSelector } from "react-redux";
import { useMatch } from "react-router-dom";

import { BackArrowButton } from "../../../components";
import { WizardPaths } from "../../../router/WizardRouter";
import { isSavedProfiles } from "../store/wizard.selectors";

export const GoPrevStep = (props) => {
  const isMultiple = useMatch(WizardPaths.Multiple);
  const hasSavedProfiles = useSelector(isSavedProfiles);

  if (isMultiple) {
    return !hasSavedProfiles ? <BackArrowButton {...props} /> : null;
  }

  return <BackArrowButton {...props} />;
};
